import { Overlay } from "@components/Overlay";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Intercom } from "@services";

export const ChangeDetailsModal = () => {
  const { dismiss } = useModal();

  return (
    <Overlay
      title={i18n.t(Translations.ChangeEmployerDetailsTitle)}
      subtitle={i18n.t(Translations.ChangeEmployerDetailsSubtitle)}
      cta={{
        primary: {
          title: i18n.t(Translations.ChangeEmployerDetailsPrimaryCTA),
          onClick: () => {
            Intercom.showChat();
            dismiss();
          },
        },
        secondary: {
          title: i18n.t(Translations.ChangeEmployerDetailsSecondaryCTA),
          onClick: dismiss,
        },
      }}
      horizontal
    />
  );
};
